import * as m from "~/paraglide/messages.js";

/**
 * The trailing mark on a link that opens elsewhere: the arrow the design draws,
 * plus the words a screen reader needs, because an arrow glyph announces
 * nothing. Every outbound action on the site carries this one node so the two
 * halves cannot drift apart.
 */
export function NewTab() {
  return (
    <>
      {" "}
      <span aria-hidden="true">↗</span>
      <span className="sr-only">({m.read_opens_new_tab()})</span>
    </>
  );
}
